function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.5213 10.6204C10.2632 10.6204 10.0535 10.4115 10.0527 10.1531C10.0519 9.8943 10.2611 9.68376 10.52 9.68303C11.6973 9.67936 12.8174 8.96851 13.6739 7.68132C14.4959 6.44587 14.9789 4.83022 15.0525 3.09008H12.988C12.7292 3.09008 12.5194 2.88027 12.5194 2.62139C12.5194 2.36251 12.7292 2.15269 12.988 2.15269H15.5311C15.79 2.15269 15.9998 2.36251 15.9998 2.62139C15.9998 4.72147 15.4509 6.7028 14.4544 8.20066C13.4191 9.75638 12.023 10.6158 10.5229 10.6204C10.5224 10.6204 10.5219 10.6204 10.5213 10.6204Z",
  fill: "#FF8E1D"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.48041 10.6204C5.4798 10.6204 5.47943 10.6204 5.47895 10.6204C3.97888 10.6158 2.58257 9.75638 1.54742 8.20066C0.550836 6.7028 0.00195312 4.72147 0.00195312 2.62139C0.00195312 2.36251 0.211766 2.15269 0.470646 2.15269H3.01367C3.27255 2.15269 3.48236 2.36251 3.48236 2.62139C3.48236 2.88027 3.27255 3.09008 3.01367 3.09008H0.949225C1.02282 4.83022 1.5058 6.44587 2.32784 7.68132C3.1843 8.96851 4.30441 9.67936 5.48175 9.68303C5.74063 9.68376 5.94983 9.8943 5.94898 10.1531C5.94825 10.4115 5.73856 10.6203 5.48041 10.6204Z",
  fill: "#FFB023"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.0209 0.998047H2.98041C2.72165 0.998047 2.51172 1.20786 2.51172 1.46674C2.51172 4.21994 3.05157 6.81582 4.03167 8.77603C4.65965 10.0319 5.42762 10.9435 6.27688 11.4654V14.0172C6.27688 14.2761 6.48682 14.4859 6.74558 14.4859H9.25577C9.51465 14.4859 9.72446 14.2761 9.72446 14.0172V11.4654C10.5737 10.9436 11.3418 10.0319 11.9697 8.77603C12.9498 6.81582 13.4896 4.21994 13.4896 1.46674C13.4896 1.20786 13.2798 0.998047 13.0209 0.998047Z",
  fill: "#FFD12B"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.72477 14.0172V11.4654C10.574 10.9436 11.3421 10.0319 11.97 8.77603C12.9501 6.81582 13.4899 4.21994 13.4899 1.46674C13.4899 1.20786 13.2801 0.998047 13.0212 0.998047H8.00098V14.4859H9.25607C9.51495 14.4859 9.72477 14.2761 9.72477 14.0172Z",
  fill: "#FFB023"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.5115 13.5485H5.49137C4.54092 13.5485 3.76758 14.3219 3.76758 15.2723V16.5274C3.76758 16.7861 3.97739 16.996 4.23627 16.996H11.7666C12.0255 16.996 12.2353 16.7861 12.2353 16.5274V15.2723C12.2353 14.3219 11.4621 13.5485 10.5115 13.5485Z",
  fill: "#FF8E1D"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.511 13.5485H8.00098V16.996H11.7661C12.025 16.996 12.2348 16.7861 12.2348 16.5274V15.2723C12.2348 14.3219 11.4616 13.5485 10.511 13.5485Z",
  fill: "#FF6D15"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.2677 16.996H3.73334C3.47458 16.996 3.26465 16.7862 3.26465 16.5274C3.26465 16.2685 3.47458 16.0587 3.73334 16.0587H12.2677C12.5266 16.0587 12.7364 16.2685 12.7364 16.5274C12.7364 16.7862 12.5266 16.996 12.2677 16.996Z",
  fill: "#FFB023"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.2682 16.0587H8.00098V16.996H12.2682C12.527 16.996 12.7368 16.7862 12.7368 16.5274C12.7368 16.2685 12.527 16.0587 12.2682 16.0587Z",
  fill: "#FF8E1D"
});

var SvgCup = function SvgCup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cup.8aabb060.svg";
export { ForwardRef as ReactComponent };